module.exports = __webpack_public_path__ + "img/figure-11.4534ae15.png";